/** Path segments for expected missing-resource 404s (no S3 object). */
export const SENTRY_IGNORED_404_PATH_SEGMENTS = ['thumbnail_url', 'image_url'] as const;

/**
 * Returns true when a 404 Response URL is an expected missing signed-image endpoint
 * and should not be reported to Sentry.
 */
export function isIgnoredNotFoundApiUrl(responseUrl: string | undefined): boolean {
  if (!responseUrl) return false;

  let pathname = responseUrl;
  try {
    pathname = new URL(responseUrl).pathname;
  } catch {
    // Relative or malformed URL — match against the raw string segments.
  }

  const segments = pathname.split('/').filter(Boolean);
  return SENTRY_IGNORED_404_PATH_SEGMENTS.some((segment) => segments.includes(segment));
}
